import React, { useState } from "react";

import Depreciation from "./Depreciation";
import RegistrationDetails from "./RegistrationDetails";
import Insurance from "./Insurance";
import carImage from "../../../images/Car.png";

function VehicleRight({ response }) {
  const [anchorSelected, setAnchorSelected] = useState("Overview");
  const anchorOptions = [
    "Overview",
    "Depreciation Value",
    "Registration Details",
    "Insurance & Challan",
  ];
  return (
    <div className=" px-4">
      <div className=" w-full text-sm font-semibold flex">
        {anchorOptions.map((option, index) => (
          <div className="px-3 ">
            <button
              key={index}
              className={` py-[6px]   ${
                anchorSelected === option
                  ? " border-b-[3px] border-[#00394d] "
                  : ""
              }`}
              onClick={() => setAnchorSelected(option)}
            >
              {option}
            </button>
          </div>
        ))}
      </div>
      <div className=" h-[calc(100vh-280px)]  overflow-y-auto mt-2">
        {/* overView */}
        {/* {anchorSelected === "Overview" && (
          <div className="mt-[30px] max-w-[380px] ">
            <img src={vehicleBig} width={330} height={200} alt="" />
            <VehicleBadge vehicle={response} />
          </div>
        )} */}
        {(anchorSelected === "Depreciation Value" ||
          anchorSelected === "Overview") && (
          <div className=" w-[400px] mt-[20px]">
            <Depreciation vehicle={response} />
          </div>
        )}
        {(anchorSelected === "Registration Details" ||
          anchorSelected === "Overview") && (
          <div className=" w-[380x] mt-[30px]">
            <RegistrationDetails vehicle={response} />
          </div>
        )}
        {(anchorSelected === "Insurance & Challan" ||
          anchorSelected === "Overview") && (
          <div className=" w-[380x] mt-[30px]">
            <Insurance vehicleDetails={response} />
          </div>
        )}
      </div>
    </div>
  );
}

export default VehicleRight;
